export function getSidebarWidth() {
    return 360;
}
